import DsForm from './src/index.vue'

export default DsForm